import type { NestedFilter } from '@@partner:graphql/types'

import React, { useCallback, useState } from 'react'

import { Form, CheckPicker, Tag, Button, Input } from 'rsuite'
import LegacySearchIcon from '@rsuite/icons/legacy/Search'

import './BusinessProfilesFilter.scss'
import { getSearchableBusinessProfilesStatus, prepareBusinessProfilesFilter } from '@@partner:helpers/businessProfiles'

export interface BusinessProfilesFiltersType {
  xid: string
  name: string
  tin: string
  status: string[]
}

export interface BusinessProfilesFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
}

const AVAILABLE_CUSTOMER_STATUSES = getSearchableBusinessProfilesStatus()

const defaultFilter: BusinessProfilesFiltersType = {
  status: [],
  xid: '',
  name: '',
  tin: '',
}

export default function BusinessProfilesFilter ({
  onFilterChanged
}: BusinessProfilesFilterProps) {
  const [ state, setState ] = useState<BusinessProfilesFiltersType>(defaultFilter)

  const handleFormSubmit = useCallback(() => {
    onFilterChanged(prepareBusinessProfilesFilter(state))
  }, [ onFilterChanged, state ])

  const makeFieldChangeHandler = useCallback(
    (name: string) => (e: any) => {
      setState((state) => ({
        ...state,
        [name]: e
      }))
    },
    []
  )

  const handleBusinessProfileStatusChange = useCallback(
    (status: string[] = []) => {
      setState((state) => ({
        ...state,
        status
      }))
    },
    []
  )

  return (
    <Form
      formValue={state}
      className="BusinessProfilesFilter"
      onSubmit={handleFormSubmit}
    >
      <div className="BusinessProfilesFilter__Filters">
        <div className="BusinessProfilesFilter__Filters__Row">
          <Form.Group>
            <Input
              value={state.xid}
              placeholder="ID в учетной системе"
              onChange={makeFieldChangeHandler('xid')}
              size="sm"
            />
          </Form.Group>
          <Form.Group>
            <Input
              value={state.name}
              placeholder="Название"
              onChange={makeFieldChangeHandler('name')}
              size="sm"
            />
          </Form.Group>
        </div>
        <div className="BusinessProfilesFilter__Filters__Row">
          <Form.Group>
            <Input
              value={state.tin}
              placeholder="БИН/ИИН"
              onChange={makeFieldChangeHandler('tin')}
              size="sm"
            />
          </Form.Group>
          <CheckPicker
            value={state.status}
            data={AVAILABLE_CUSTOMER_STATUSES}
            searchable={false}
            placeholder="Статус"
            valueKey="value"
            labelKey="label"
            size="sm"
            style={{ maxWidth: 260 }}
            renderMenuItem={(label, item: any) => (
              <Tag key={item?.value} color={item?.color}>
                {label}
              </Tag>
            )}
            onChange={handleBusinessProfileStatusChange}
          />
        </div>
      </div>
      <div className="BusinessProfilesFilter__Controls">
        <Button type="submit" size="lg" color="green" appearance="primary">
          <LegacySearchIcon /> Поиск
        </Button>
      </div>
    </Form>
  )
}
